import React, { useState } from "react";
import { motion } from "framer-motion";

const certificates = [
  {
    src: "/certifications/DAP.png",
    alt: "Fabric Analytics Engineer Certificate",
  },
  {
    src: "/certifications/DEP.png",
    alt: "Fabric Data Engineer Certificate",
  },
];

const RightBanner = () => {
  const [frontIndex, setFrontIndex] = useState(0);

  const handleClick = () => {
    setFrontIndex((prev) => (prev === 0 ? 1 : 0));
  };

  return (
    <div
      className="w-full lgl:w-1/2 flex justify-center items-center relative"
      style={{
        perspective: "900px",
        height: "450px",
        transform: "translateX(30px)", // 👉 moved slightly to the right
      }}
    >
      {certificates.map((cert, i) => {
        const isFront = i === frontIndex;

        return (
          <motion.img
            key={cert.src}
            src={cert.src}
            alt={cert.alt}
            onClick={handleClick}
            className="absolute object-contain"
            style={{
              width: isFront ? 580 : 545,
              height: isFront ? 425 : 400,
              zIndex: isFront ? 2 : 1,
              cursor: "pointer",
              top: isFront ? 0 : -24,
              left: isFront ? 0 : -22,
            }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, rotateY: [-8, 8, -8] }}
            transition={{
              opacity: { duration: 0.6, ease: "easeInOut" },
              rotateY: { duration: 8, ease: "easeInOut", repeat: Infinity },
            }}
          />
        );
      })}
    </div>
  );
};

export default RightBanner;
